import React from "react";
import { Link } from "react-router-dom";

function AboutSix({ DataAbout }) {
  return (
    <div>
      <>
        {/* short discription about company area  */}
        <div className="short-discription-area tmp-section-gapBottom">
          <div className="container  plr_sm--15">
            <div className="row">
              <div className="col-lg-12">
                <div className="short-discription-between-area">
                  <h2
                    className="title wow fadeInUp"
                    data-wow-duration=".8s"
                    data-wow-delay=".1s"
                  >
                    {DataAbout?.title1}
                  </h2>
                  <div className="discription-area">
                    <p
                      className="disc wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".1s"
                    >
                      {DataAbout?.desc}
                    </p>
                    <Link
                      to={DataAbout?.link}
                      className="btn-readmore d-flex wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".3s"
                    >
                      {DataAbout?.linkName}
                      <i className="fa-light fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* short discription about company area end */}
        {/* about company wrapper */}
        <section className="about-company-area tmp-section-gapBottom">
          <div className="row align-items-center  plr_sm--15 plr_md--15">
            <div className="col-lg-4 offset-lg-2 mb_md--50 mb_sm--30">
              <div className="split-inner">
                <h2
                  className="title sal-animate mb--40 wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  {DataAbout?.title2}
                </h2>
                <p
                  className="description sal-animate mb--25 wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".3s"
                >
                  {DataAbout?.desc2}
                </p>

                <div
                  className="view-more-button mt--35 sal-animate d-flex wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".9s"
                >
                  <Link className="tmp-btn btn-primary" to={DataAbout?.link2}>
                    {DataAbout?.linkName2}
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 wow fadeInRight"
              data-wow-duration=".8s"
              data-wow-delay=".3s"
            >
              <div className="thumbnail image-right-content">
                <img src={DataAbout?.img} alt="split Images" />
              </div>
            </div>
          </div>
        </section>
        {/* about company wrapper end */}
      </>
    </div>
  );
}

export default AboutSix;
